import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { CREATE_COURSE, UPDATE_COURSE } from "../../../Schema/Course";

const useShiftForm = ({ handleClose, resetForm, setRefetch }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createCourse] = useMutation(CREATE_COURSE, {
    onCompleted: ({ createCourse }) => {
      setLoading(false);

      if (createCourse?.isSuccess === true) {
        setAlert(true, "success", createCourse?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createCourse?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateCourse] = useMutation(UPDATE_COURSE, {
    onCompleted: ({ updateCourse }) => {
      setLoading(false);
      if (updateCourse?.isSuccess === true) {
        setAlert(true, "success", updateCourse?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateCourse?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  return { createCourse, updateCourse, loading, setLoading };
};

export default useShiftForm;
